const ShadowConfig = {
    BIAS: -0.001,
    MAP_SIZE: {
        width: 4096,
        height: 4096,
    },
};
export { ShadowConfig };
